import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loanData: null,
  loading: false,
  error: null,
};

const loanDetailsSlice = createSlice({
  name: "loanDetails",
  initialState,
  reducers: {
    fetchLoanDetails: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchLoanDetailsSuccess: (state, action) => {
      state.loading = false;
      state.loanData = action.payload;
    },
    fetchLoanDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchLoanDetails,
  fetchLoanDetailsSuccess,
  fetchLoanDetailsFailure,
} = loanDetailsSlice.actions;

export default loanDetailsSlice.reducer;
